import React, {Component} from 'react'
import './delivery-detail.less'
import {Col, Input, message, Popconfirm, Row, Table, Tabs, Timeline} from 'antd'
import {baseUrl, getOrderShort, getOrderTrails} from '../../api'
import axios from 'axios'
import authorizeBase from "../../components/authorize/authorizeBase";
import DeliveryStep from '../../components/step/delivery-step'
import {ReactBingmaps} from "react-bingmaps";
import ajax from "../../api/ajax";
import RouteStepViewForm from "../route/route-step-view";
const AuthPopconfirm = authorizeBase(Popconfirm)
let orderId = '';
const {TabPane} = Tabs;
const {TextArea} = Input;
class DeliveryDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            order: {
                orderNo: '',
                containerNum: '',
                createdDt: '',
                deliveryDt: '',
                start: '',
                destination: ''
            },
            dataSource: [],
            destinationCity: '',
            originAdd: '',
            destinaAdd: '',
            page: 1,
            pageSize: 10,
            total: 0,
            vehicleDataSource: [],
            page2: 1,
            pageSize2: 10,
            vehicleCount: 0,
            total2: 0,
            bingmapKey: "AuXjIRtmvSChnWxFOVerDnOU8EZyQ-LXI-w9zsxkmEYFR9DmScWoZFM88YcTw6uv",
            center: [],
            rowId: 1,
            mapData: [],
            stepDescription: [],
            currentTrailNo: '',
            noteDataSource:[],
            pageNote: 1,
            totalNote: 0,
            orderNodes:[],
        }
    }
    getVehicle = (pageNum) => {
        this.setState({
            page2: pageNum,// 保存pageNum, 让其它方法可以看到
            pageSize: 10
        })

        axios.get(baseUrl + '/api/v1/p/orderVehicleList', { // 配置对象
            params: {orderId: orderId, pageNum: pageNum, pageSize: this.state.pageSize2} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                if (result.data && result.data.rows && result.data.rows.length > 0) {
                    const data = [];
                    for (let i = 0; i < result.data.rows.length; i++) {
                        result.data.rows[i].key = i;
                        data.push(result.data.rows[i]);
                    }
                    this.setState({
                        total2: result.data.total,
                        vehicleDataSource: data,
                        vehicleCount: result.data.total
                    })
                }
            } else {
                message.error(result.message)
                return false;
            }
        });

    }

    // 查询详情
    getOrderShortFunc = async (id) => {
        let result = await getOrderShort(id)
        if (result.code === 200) {
            var data = result.data;
            data.start = data.originCountry + (data.originProvince ? data.originProvince : '') + data.originCity;
            data.destination = data.destinationCountry + (data.destinationProvince ? data.destinationProvince : '') + data.destinationCity;
            const originAdd = data.originCountry + ' ' + data.originCity
            const destinaAdd = data.destinationCountry + ' ' + data.destinationCity
            this.setState({
                order: data,
                destinationCity: '到达' + data.destinationCity,
                commitDt: data.commitDt,
                originAdd,
                destinaAdd
            })
            if(data.routeType==='N'){
                this.getOrderNodes(orderId);
            }
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }
    }
    componentDidMount() {
        orderId = this.props.location.state.orderId;

        this.getOrderShortFunc(orderId);
        axios.get(baseUrl + '/api/v1/p/orderDelivery', { // 配置对象
            params: {orderId} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                if (result.data && result.data.length > 0) {
                    const data = [];
                    for (let i = 0; i < result.data.length; i++) {
                        result.data[i].key = i;
                        data.push(result.data[i]);
                    }
                    this.setState({
                        dataSource: data,
                        total: result.data.total,
                        count: result.data.length,
                        mapData: result.data,
                        center: [],
                        infoboxesWithPushPins: [],
                        polyline: {"location": [], "option": {strokeColor: '', strokeThickness: 0}}
                    })
                    this.timer_two(data[0].trailNo);
                    this.getRightOrderTrails(data[0].trailNo)
                    this.setState({currentTrailNo: data[0].trailNo})
                }
            } else {
                message.error(result.message)
                return false;
            }
        });
        this.getNotes(1);
        this.getVehicle(1);
    }
    timer_two = (record) => setTimeout(
        () => {
            this.getOrderTrails(record)
        },
        2000
    );
    getOrderTrails = async (trailNo) => {
        if (trailNo) {
            let result = await getOrderTrails({trailNo, type: 'normal', orderId})
            if (result.code === 200 && result.data.length > 0) {
                let ret = []
                let ret2 = []
                result.data.forEach((item) => {
                    //console.log(item)
                    let address =
                        '位置:' + item.address + '<br/>' +
                        '设备号:' + item.trailNo + '<br/>' +
                        '到达时间:' + item.activeDt + '<br/>' +
                        '纬度:' + item.latitude + '<br/>' +
                        '经度:' + item.longitude + '<br/>' +
                        '温度(摄氏):' + item.uTemperature + '<br/>' +
                        '电量(%):' + item.uBattery + '<br/>' +
                        '信号强度:' + item.uSignalstrength;
                    ret.push({
                        "location": [item.latitude, item.longitude],
                        "addHandler": "mouseover",
                        "infoboxOption": {title: "", description: address, maxHeight: 300, maxWidth: 420},
                        "pushPinOption": {title: "", description: "", color: 'DodgerBlue'},
                        "infoboxAddHandler": {
                            "type": "click", callback: () => {
                                this.scrollInto("step" + item.id)
                            }
                        },
                        "pushPinAddHandler": {
                            "type": "click", callback: () => {
                                this.scrollInto("step" + item.id)
                            }
                        }
                    })
                    ret2.push([item.latitude, item.longitude])
                });

                this.setState({
                    center: ret2[0],
                    infoboxesWithPushPins: ret,
                    polyline: {"location": ret2, "option": {strokeColor: 'DodgerBlue', strokeThickness: 4}},
                });
            } else if (result.code === 200) {
                this.setState({
                    center: [],
                    infoboxesWithPushPins: [],
                    polyline: {"location": [], "option": {strokeColor: '', strokeThickness: 0}},
                });
            } else {
                message.error(result.message)
            }
        }
    }
    getRightOrderTrails = async (trailNo) => {
        if (trailNo) {
            let result = await getOrderTrails({trailNo, type: 'all', orderId})
            if (result.code === 200 && result.data.length > 0) {
                let description = []
                result.data.forEach(function (item) {
                    let sesObj = {
                        id: item.id,
                        sts: item.sts,
                        activeDt: item.activeDt,
                        address: item.address,
                        latitude: item.latitude,
                        longitude: item.longitude,
                        uTemperature: item.uTemperature,
                        uSignalstrength: item.uSignalstrength

                    }
                    description.push(sesObj)
                });
                this.setState({
                    stepDescription: description
                });
            } else if (result.code === 200) {
                this.setState({
                    stepDescription: []
                });
            } else {
                message.error(result.message)
            }
        }
    }
    tabChange = (key) => {
        this.getOrderTrails(key)
        this.getRightOrderTrails(key)
        this.setState({currentTrailNo: key})
    }
    steDescription = (obj) => {
        if (obj) {
            return <div>
                <div>{obj.activeDt}</div>
                <div>{obj.address}</div>
                <div>经度:{obj.latitude}</div>
                <div>纬度:{obj.longitude}</div>
                <div>温度(摄氏):{obj.uTemperature}</div>
                <div>信号强度:{obj.uSignalstrength}</div>
            </div>
        }

    };
    scrollInto = (id) => {
        let anchorElement = document.getElementById(id);
        if (anchorElement) {
            this.setState({
                activeId: id,
            })
            anchorElement.scrollIntoView({block: "start", inline: "start"});
        } else {
            console.log(id + " not found")
        }
    }
    setColletDt = (date) =>{
        if(date){
            this.setState({
                deliveryDt:date
            })
        }

    }

    exportTrain = () => {
        window.location.href=baseUrl+'/api/v1/p/opt/export?orderId='+orderId
    }
    getNotes = (pageNum) => {
        this.setState({
            pageNote: pageNum
        })

        axios.get(baseUrl + '/api/v1/p/orderNoteList', { // 配置对象
            params: {orderId: orderId, pageNum: pageNum, pageSize: this.state.pageSize} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                if (result.data && result.data.rows && result.data.rows.length > 0) {
                    const data = [];
                    for (let i = 0; i < result.data.rows.length; i++) {
                        result.data.rows[i].key = i;
                        result.data.rows[i].optDt = (result.data.rows[i].optDt ? result.data.rows[i].optDt.substr(0, 10) : '')
                        data.push(result.data.rows[i]);
                    }
                    this.setState({
                        totalNote: result.data.total,
                        noteDataSource: data,
                    })
                }
            } else {
                message.error(result.message)
                return false;
            }
        });

    }
    getOrderNodes = async (orderId) => {
        this.setState({
            loading: true,
        })
        let result = await ajax(baseUrl + "/api/v1/p/yg/orderNodes", {orderId});
        if (result && result.data) {
            let nodes = [];
            if (nodes) {
                nodes = result.data.nodeVos.sort((a, b) => {
                    return a.indx - b.indx
                })
            }
            this.setState({
                orderNodes: nodes,
                routeIOType: result.data.type,
            })
        } else {
            message.error("轨迹信息不存在！")
        }
        this.setState({
            loading: false
        })
    }
    render() {
        const {mapData,stepDescription,noteDataSource,dataSource, total, page, pageSize, page2, pageSize2, total2, vehicleDataSource} = this.state;
        const columns = [
            {
                title: '序号',
                dataIndex: '',
                render: (text, record, index) => (
                    <span>{index + 1 + (page - 1) * pageSize}</span>
                )
            },
            {
                title: '厂封号',
                dataIndex: 'factoryNo',
            },
            {
                title: '运单号',
                dataIndex: 'deliveryNo',
            },
            {
                title: '装箱地点',
                dataIndex: 'boxLocation',
            },
            {
                title: '集装箱号',
                dataIndex: 'boxNo',
            },
            {
                title: 'GPS编号',
                dataIndex: 'trailNo',
            }/*, {
                title: '操作',
                dataIndex: 'opt',
                render: (text, record) => {
                    return <span><AuthPopconfirm authority="delivery_view:get_trail"  title="是否确定获取轨迹?" onConfirm={() => this.getTrailsByApi(record.trailNo)}>
                            <a>获取轨迹</a>
                        </AuthPopconfirm></span>;
                }
            }*/
        ];

        const vehicleColumns = [
            {
                title: '序号',
                dataIndex: '',
                render: (text, record, index) => (
                    <span>{index + 1 + (page2 - 1) * pageSize2}</span>
                )
            },
            {
                title: '车牌号',
                dataIndex: 'truckNo',
                editable: true,
            },
            {
                title: '司机姓名',
                width: '100',
                dataIndex: 'name',
                editable: true,
            },
            {
                title: '身份证号码',
                width: '100',
                dataIndex: 'identification',
                editable: true,
            },
            {
                title: '手机号码',
                width: '100',
                dataIndex: 'phone',
                editable: true,
            }
        ];
        const noteColumns = [
            {
                title: '序号',
                dataIndex: '',
                render: (text, record, index) => (
                    <span>{index + 1 + (this.state.pageNote - 1) * pageSize}</span>
                )
            },
            {
                title: '日期',
                dataIndex: 'optDt',
            },
            {
                title: '备注说明',
                dataIndex: 'note',
            }
        ];
        return (
            <div className='info box-shadow padding-20'>
                <div className="head-title">
                    <span className='title'>物流详情</span>
                </div>
                <br/>
                <div className="info-detail">
                    <Row className='info-detail-item'>
                        <Col span={6}>
                            <span className='label'>订单编号 : </span>
                            <span> {this.state.order.orderNo} </span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>企业名称: </span>
                            <span>{this.state.order.entName}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>起运地 : </span>
                            <span>{this.state.originAdd}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>转关地: </span>
                            <span>{this.state.order.destinationStartCountry} {this.state.order.destinationStartCity}</span>
                        </Col>
                    </Row>
                    <Row className='info-detail-item'>
                        <Col span={6}>
                            <span className='label'>目的地 : </span>
                            <span>{this.state.destinaAdd}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>还箱地: </span>
                            <span>{this.state.order.boxReturnStation}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>集装箱数 : </span>
                            <span>{this.state.order.containerNum}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>创建时间 : </span>
                            <span>{this.state.order.createdDt}</span>
                        </Col>
                        {/*<Col span={8}>
                            <span className='label'>提货时间 : </span>
                            <span>{this.state.deliveryDt}</span>
                        </Col>*/}
                    </Row>
                </div>
                <div className='info-item'>
                    <div className="info-item-title">
                        物流信息
                    </div>
                    <div className="info-item-content">
                        <Table columns={columns}  bordered dataSource={dataSource} pagination={{
                            current: this.state.page,
                            total: total,
                            onChange: (page, pageSize) => {
                                this.setState({page: page, pageSize: pageSize})
                            }
                        }} size="middle"/>
                    </div>

                    <div className="info-item-title">
                        <div className='flex-between'>
                            <div>车辆信息</div>
                        </div>
                    </div>
                    <div className="info-item-content">
                        <Table columns={vehicleColumns}
                               scroll={{x: 'auto'}}
                               bordered
                               rowClassName={() => 'editable-row'}
                               pagination={{
                                   current: this.state.page2,
                                   total: total2,
                                   showQuickJumper: true,
                                   onChange: this.getVehicle
                               }
                               }
                               dataSource={vehicleDataSource}
                               size="middle"/>
                    </div>

                    {/*<div className="info-item-title">
                        <div className='flex-between'>
                            <div>备注信息</div>
                        </div>
                    </div>
                    <div className="info-item-content">
                        <Table columns={noteColumns}
                               scroll={{x: 'auto'}}
                               bordered
                               pagination={ {
                                   current: this.state.pageNote,
                                   total: this.state.totalNote,
                                   showQuickJumper: true,
                                   onChange: this.getNotes
                               } }
                               dataSource={noteDataSource}
                               size="middle"/>
                    </div>*/}

                    <div className="info-item-title">
                        <div className='flex-between'>
                            <div>其他说明</div>
                        </div>
                    </div>
                    <div style={{marginTop: '20px'}}>
                        <TextArea style={{height: '100px', resize: 'none'}} readonly ={true} value={this.state.order.otherExplain}/>
                    </div>

                    <br/>
                    <div className="info-item-title">
                        轨迹信息
                        {/*<Button type='primary' authority="delivery_edit:trail_export" onClick={this.exportTrain} style={{float:'right'}}>导出</Button>*/}
                    </div>
                    <div className="info-item-content">
                        {this.state.order.routeType==='N'?
                            <RouteStepViewForm nodes={this.state.orderNodes} routeType={this.state.routeIOType} readOnly={true} loading={this.state.loading} reload={this.getOrderNodes}/>
                            :<DeliveryStep {...this.props} action={this.state.stepEditable?'edit':null} setColletDt={this.setColletDt}/>}
                    </div>
                    <div className="info-item-title">
                        轨迹展示
                    </div>
                    {
                        mapData ? <Tabs type="card" style={{marginTop: '10px'}} onChange={this.tabChange}>
                            {mapData.map(t => {
                                return t.trailNo?<TabPane tab={t.trailNo} key={t.trailNo}></TabPane>:''
                            })}
                        </Tabs> : null
                    }

                    <div className='track-map-box '>
                        <div className="track-step-map" id="bingmap">
                            <ReactBingmaps
                                //center = {[13.0827, 80.2707]}
                                zoom={8}
                                center={this.state.center}
                                bingmapKey={this.state.bingmapKey}
                                polyline={this.state.polyline}
                                infoboxesWithPushPins={this.state.infoboxesWithPushPins }
                            >
                            </ReactBingmaps>
                        </div>
                        <div className='track-map-list'>
                            {stepDescription ? <Timeline>
                                {stepDescription.map(des => (
                                    <Timeline.Item id={"step" + des.id} key={"step" + des.id}><p
                                        style={this.state.activeId === ("step" + des.id) ? {
                                            color: "#2975d5",
                                            paddingTop: 3
                                        } : (des.sts !== 'N' ? {
                                            color: "rgba(0, 0, 0, 0.9)",
                                            paddingTop: 3
                                        } : {color: "rgba(0,0,0,.45)", paddingTop: 3})}>{this.steDescription(des)}</p>
                                    </Timeline.Item>
                                ))}
                            </Timeline> : null}

                        </div>
                    </div>

                </div>
            </div>

        )
    }
}
export default DeliveryDetail